export default "<div id=\"video-container\" [innerHTML]=\"videoElement\"></div>\n"